import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';

import Dropdown from './Dropdown.jsx';
import EditableField from './EditableField.jsx';
import CustomDropzone from './CustomDropzone.js';

import campaignsAPI from '../../../../../apis/campaigns';

const PushNotificationDetails = ({ campaign, appDeepLinks, onUpdate, disabled, persist = false }) => {
  const [clinics, setClinics] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { title, body, note, app_deep_link, id } = campaign;

  useEffect(() => {
    const fetchClinics = async () => {
      const response = await campaignsAPI.getClinics();
      const clinics = response.data?.data || [];
      setClinics(clinics);
    };

    fetchClinics();
  }, []);

  const handleDropzoneError = errorMessage => enqueueSnackbar(errorMessage, { variant: 'error' });

  const selectedAppDeepLink = appDeepLinks?.find(deepLink => app_deep_link === deepLink.link);

  useEffect(() => {
    if (selectedAppDeepLink && !selectedAppDeepLink.id && id) onUpdate({ id: '', resource: '' });
  }, [selectedAppDeepLink, id, onUpdate]);

  return (
    <Wrapper>
      <Container>
        <EditableField
          value={title}
          label='Title'
          onChange={(title) => onUpdate({title})}
          persist={persist}
          disabled={disabled}
          inputProps={{ maxLength: 80 }}
          helperText={`${title.length}/${80}`}
        />
        <EditableField
          value={body}
          label='Body'
          onChange={(body) => onUpdate({ body })}
          persist={persist}
          disabled={disabled}
          inputProps={{ maxLength: 300 }}
          helperText={`${body.length}/${300}`}
          multiline
        />
        <Dropdown
          label='Key for Deep Linking'
          items={appDeepLinks?.length && appDeepLinks.map(deepLink => ({
            title: deepLink.link,
            value: deepLink.link,
          }))}
          value={app_deep_link}
          onChange={(app_deep_link) => onUpdate({ app_deep_link })}
          disabled={disabled}
        />
        {clinics?.length > 0 && app_deep_link && selectedAppDeepLink?.id && (
          <Dropdown
            label='Select Clinic'
            items={clinics?.length && clinics.map(clinic => ({
              title: clinic.name,
              value: clinic._id,
            }))}
            value={id}
            onChange={(id) => onUpdate({ id, resource: selectedAppDeepLink?.resource })}
            disabled={disabled}
          />
        )}
      </Container>
      <Container>
        <EditableField
          value={note}
          label='Internal Note'
          onChange={(note) => onUpdate({ note })}
          persist={persist}
          disabled={disabled}
        />
      </Container>
      <Container>
        <CustomDropzone
          acceptedFiles={'[.csv]'}
          onSubmit={(file) => onUpdate({ file })}
          onError={handleDropzoneError}
          disabled={disabled}
        />
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  border-radius: 15px;
  margin-top: 20px;
  padding: 20px;
  width: 50%;
  background-color: white;
`;

export default PushNotificationDetails;
